export default __webpack_public_path__ + "static/fun3-30b4facf1ad6b5a3f2233921bcdec1a7.jpg";